var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTickFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.399,
    height: 25.399,
    viewBox: "0 0 25.399 25.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "greenTickFill",
    d: "M12.7,0A12.7,12.7,0,1,0,25.4,12.7,12.7,12.7,0,0,0,12.7,0ZM19.97,8.933l0,0a.019.019,0,0,1-.018.007L9.407,19.485,5.146,15.224A1.428,1.428,0,0,1,7.165,13.2l2.241,2.241,8.522-8.521A1.432,1.432,0,1,1,19.97,8.933Z",
    fill: "#390"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickFill);
export default __webpack_public_path__ + "static/media/greenTickFill.73b2f869124f449597905e1d9264ee73.svg";
export { ForwardRef as ReactComponent };